export default function Sass_Variables() {
  return (
    <div>
      <h1>Sass Variables</h1>
    </div>
  );
}
